export default __webpack_public_path__ + "media/images/images/carousel/21-1259d102cbd01e6e47774e55c27b064f.jpg";